import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderExpressEdiStopGrid extends Layout {
    sourceEdiStop: DataSource;
    tableLtxStopGrid: Table;
}
